<template lang="pug">
  div(:class="$style.journalHomework")
    div(:class="$style.table")
      div(:class="[$style.row, $style['--header']]")
        div(:class="$style.col") Дата
        div(:class="$style.col") Тема занятий
        div(:class="$style.col") Домашниее задание

      div(v-for="(homework, idx) in homeworks" :class="$style.row" :key="idx")
        div(:class="$style.col") {{ $moment(homework.dateLesson, 'DD.MM.YYYY').format('DD.MM') }}
        div(:class="$style.col") {{ homework.topicLesson }}
        div(:class="[$style.col, $style['--task']]")
          div(v-html="homework.task")
          button(:class="$style.editBtn" @click="showHomeworkHandler(homework)")
            v-icon(name="edit")
</template>

<script>
  import { mapMutations } from 'vuex';

  export default {
    name: 'journalHomework',
    props: {
      homeworks: {
        type: Array,
        default: () => ([])
      },
      currentDiscipline: {
        type: [String, null],
        default: null
      }
    },

    methods: {
      ...mapMutations(["setModalData"]),

      showHomeworkHandler(homework) {
        const obj = {
          name: "HomeWorkModal",
          data: {
            note: homework.task || '',
            theme: homework.topicLesson,
            readOnly: false,
            files: homework.url,
            cb: async formData => {
              const success = await this.saveHomeWork(formData, homework);

              if (success) {
                this.$emit('update-homework');
              }
            },
            title: 'Домашнее задание',
          },
        };

        this.setModalData(obj);
      },

      async saveHomeWork(formData, homework) {
        formData.append('subjectCode', this.currentDiscipline);
        const task = formData.get('note');
        formData.append('task', task);
        formData.append('lessonDatetime',`${homework.dateLesson} ${homework.timeLesson}`);

        try {
          const { data: { errors } } = await this.axios.post('/api/ejournal/lessons', formData, { params: { '_method': 'PUT' } });

          if (errors) {
            this.$notify.error({
              message: 'Ошибка при сохранении домашнего задания, повторите попытку позже',
              duration: 3000
            })
            return false;
          } else {
            this.$notify.success({
              message: 'Домашняя работа успешно сохранена',
              duration: 3000
            })
          }

          this.setModalData(null);
          return true;
        } catch (error) {
          console.warn('Failed fetch saveHomeWork', error);
          return false;
        }
      },
    }
  }
</script>

<style lang="scss" module>
  .journalHomework {
    overflow: hidden;
  }

  .table {
    position: relative;
    border: 1px solid $placeholder-text-clr;
    max-height: 100%;
    max-width: 1000px;
    overflow-y: auto;
  }

  .col {
    display: flex;
    padding: 10px;

    &:not( :last-child ) {
      border-right: 1px solid $placeholder-text-clr;
    }

    &:nth-child(1) {
      width: 65px;
      flex-shrink: 0;
    }

    &:nth-child(2),
    &:nth-child(3) {
      width: 50%;
    }
  }

  .row {
    display: flex;

    &:not( :last-child ) {
      border-bottom: 1px solid $placeholder-text-clr;
    }

    &.--header {
      position: sticky;
      top: 0;
      left: 0;
      color: $placeholder-text-clr;
      background-color: $basic-white;
    }
  }

  .editBtn {
    margin-left: auto;
    color: $brand-clr-1;
  }
</style>
